import { INFORMATION, TAXI_INFORMATION } from '../../constants/information';
import './benefits.scss';

interface BenefitsProps {
  isTaxi: boolean;
}

const Benefits: React.FC<BenefitsProps> = (props: BenefitsProps) => {
  const { isTaxi } = props;

  const displayInformation = isTaxi ? TAXI_INFORMATION : INFORMATION;

  return (
    <div className="all-benefits">
      <div className="all-benefits__container">
        <h3 className="all-benefits__container__title">
          <b>Queremos que estés informado</b>
          <br />
          Revisa en qué casos no tendrás cobertura
        </h3>
        <div className="all-benefits__container__cards">
          {displayInformation.map((item) => {
            return (
              <div key={item.id}>
                <div className="all-benefits__container__cards__content">
                  <div className="all-benefits__container__cards__content__card">
                    <img
                      src={item.img}
                      alt="accident"
                      className="all-benefits__container__cards__content__card__image"
                    />
                    <div className="all-benefits__container__cards__content__card__text">
                      <p className="all-benefits__container__cards__content__card__text--sub-title">
                        {item.title}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Benefits;

Benefits.defaultProps = {
  isTaxi: false,
};
